module.exports = __webpack_public_path__ + "static/media/play-excellent.0ccc61c4.png";